<aside class="al-sidebar" sidebarResize>
  <ba-menu [menuHeight]="menuHeight"
           [sidebarCollapsed]="isMenuCollapsed"
           (expandMenu)="menuExpand()"></ba-menu>
</aside>
